// Helpers
const focusableSelector = [
  "a[href]:not([tabindex='-1'])",
  "area[href]:not([tabindex='-1'])",
  "input:not([disabled]):not([tabindex='-1'])",
  "select:not([disabled]):not([tabindex='-1'])",
  "textarea:not([disabled]):not([tabindex='-1'])",
  "button:not([disabled]):not([tabindex='-1'])",
  "iframe:not([tabindex='-1'])",
  "[tabindex]:not([tabindex='-1'])",
  "[contentEditable=true]:not([tabindex='-1'])",
].join(",");


function triggerSelfClick(e) {
  if (e.key === "Enter") {
    e.target.click();
  }
}

$(window).on("load", function () {

  $('div[data-oke-star-rating]').each((i, button) => {
    $(button).on('click', () => {
      $('body').addClass('show-okendo-reviews-widget-popup');
      $('.okendo-reviews-widget-popup').find(focusableSelector).first().focus();
    });
  });

  $('.okendo-reviews-widget-popup').each((i, popup) => {
    const inner = popup.querySelector('.okendo-reviews-widget-popup-inner');

    $(popup).on('click', () => {
      if(!inner.contains(event.target)) {
        $('body').removeClass('show-okendo-reviews-widget-popup');
      }
    });

    $(window).on('keydown', (e) => {
      if(e.key === 'Escape' && $('body').hasClass('show-okendo-reviews-widget-popup')) {
        $('body').removeClass('show-okendo-reviews-widget-popup');
      }
    });
  });
  
  console.log('Load');
});